module.exports = __webpack_public_path__ + "./images/6a67d2163bc0c486144a0712683f1251.jpg";